import React from 'react';
import {View} from 'react-native';
import {constant} from 'lodash/fp';

import ListItem from '/component/base/ListItem';
import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './Loading.style';

// Define props interface
interface LoadingProps {
  renderTitle: () => string;
}

// Functional Component with TypeScript
export const Loading: React.FC<LoadingProps> = ({
  renderTitle = constant(''),
}) => {
  const {tt} = useTranslation('reportCardContent.newCoachesReportContent');

  return (
    <View style={styles.base}>
      <Gutter style={styles.headerContainer}>
        <Text variant="heading" style={styles.header}>
          {renderTitle()}
        </Text>
      </Gutter>
      <View style={styles.listItemContainer}>
        <Gutter>
          <ListItem
            style={{base: styles.listItem}}
            label={<Text>{tt('label.activationDate', 'Activation Date')}</Text>}
            suffix={<LoadingBox style={styles.loadingBoxActivationDate} />}
          />
          <ListItem
            style={{base: styles.listItem}}
            label={<Text>{tt('label.businessCoach', 'Business Coach')}</Text>}
            suffix={<LoadingBox style={styles.loadingBoxBusinessCoach} />}
          />
          <ListItem
            style={{base: styles.listItem}}
            label={<Text>{tt('label.eqsb', 'Earned Quick Start Bonus')}</Text>}
            suffix={<LoadingBox style={styles.loadingBoxEQSB} />}
          />
          <ListItem
            style={{base: styles.listItem}}
            label={
              <Text>
                {tt(
                  'label.groupQualifyingVolume',
                  'Group Qualifying Volume for Senior Coach Rank',
                )}
              </Text>
            }
            suffix={
              <LoadingBox style={styles.loadingBoxGroupQualifyingVolume} />
            }
          />
          <ListItem
            style={{base: styles.listItem}}
            label={
              <Text>{tt('label.orderingEntities', 'Ordering Entities')}</Text>
            }
            suffix={<LoadingBox style={styles.loadingBoxOrderingEntities} />}
          />
        </Gutter>
      </View>
    </View>
  );
};
